import {type DefaultError, useMutation, type UseMutationOptions, type UseMutationResult} from "@tanstack/react-query";
import type {UrlMutationVariables} from "./queryClient";

/**
 * Same as useMutation, but variables default to {@link UrlMutationVariables} (matches defaultMutationFn).
 */
export function useCustomMutation<
    TData = unknown,
    TError = DefaultError,
    TVariables extends UrlMutationVariables = UrlMutationVariables,
    TContext = unknown,
>(
    options?: UseMutationOptions<TData, TError, TVariables, TContext>,
): UseMutationResult<TData, TError, TVariables, TContext> {
    return useMutation<TData, TError, TVariables, TContext>(options ?? {});
}
